import { FunctionComponent } from 'react';
import { useDataDogRUM } from '../../lib/hooks/useDataDogRUM';
import { AdobeTMSScript } from './AdobeTMSScript';

/**
 * Adds Global Analytics and monitoring scripts to head
 * @returns JSX.Element
 */
export const GlobalAnalyticsAndMonitoringScripts: FunctionComponent = () => {
  useDataDogRUM();
  return (
    <>
      <AdobeTMSScript />
    </>
  );
};
